// AUTOMATICALLY GENERATED, DO NOT MODIFY
export type AIRLINE_BOOKING = {
    messageLines?: (string | number)[];
    origin: string | number;
    destination: string | number;
    tentativeTender: string | number;
    tenderTimeOfDay: string | number;
    awbNum: string | number;
    promoCode: string | number;
    productType: string | number;
    targetRate: string | number;
    accountNumber: string | number;
    account: {
        name: string | number;
    };
    iataNumber: string | number;
    weightUnit: string | number;
    totalActualWeight: string | number;
    totalVolumeWeight: string | number;
    totalPieceCount: string | number;
    totalVolume: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    isKnownShipper: string | number;
    isPrescreened: string | number;
    cargoType: string | number;
    commodityType: string | number;
    is_consolidated?: string | number;
    hs_code?: string | number;
    is_military_related?: string | number;
    emergency_contact_details: string | number;
    showPerishable?: string | number | boolean | object;
    cargoTemperatureRange: string | number;
    cargoCooling: string | number;
    showDangerousGoods?: string | number | boolean | object;
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    showBatteries?: string | number | boolean | object;
    packing_instruction: string | number;
    section: string | number;
    lineItems: {
        label: string | number;
        is_per_unit?: string | number | boolean | object;
        per_unit_count: string | number;
        per_unit_cost: string | number;
        cost: string | number;
    }[];
    totalCost: string | number;
    tenantName?: string | number;
    confirmationNum: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type AIRLINE_QUOTING = {
    message?: (string | number)[];
    origin: string | number;
    destination: string | number;
    isKnownShipper: string | number;
    productType: string | number;
    weightUnit: string | number;
    totalActualWeight: string | number;
    totalVolumeWeight: string | number;
    totalPieceCount: string | number;
    totalVolume: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    tentativeTender: string | number;
    isStackable: string | number;
    cargoType: string | number;
    commodityType: string | number;
    showPerishable?: string | number | boolean | object;
    cargoTemperatureRange: string | number;
    cargoCooling: string | number;
    showDangerousGoods?: string | number | boolean | object;
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    showBatteries?: string | number | boolean | object;
    packing_instruction: string | number;
    section: string | number;
    targetRate: string | number;
    accountNumber: string | number;
    account: {
        name: string | number;
    };
    iataNumber: string | number;
    tenantName?: string | number;
    requestId: string | number;
    quoteId: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type BOOKING_CONFIRM_TO_FF = {
    ffName: string | number;
    messageLines?: (string | number)[];
    requestUrl: string | number;
    showBookingDetails?: string | number | boolean | object;
    origin: string | number;
    destination: string | number;
    quotesDetail: {
        providers: {
            name: string | number;
            logo_uri: string | number;
        };
        dropoffAddress: string | number;
        cutoff: string | number;
        dropoff_instructions: string | number;
        flightPathCount: string | number;
        pickupOrigin: string | number | boolean | object;
        flightPath: {
            length?: string | number;
            departs_at: string | number;
            origin_airport: {
                name: string | number;
            };
            origin_airport_id: string | number;
            travelTime: string | number;
            flight_number: string | number;
            arrives_at: string | number;
            destination_airport: {
                name: string | number;
            };
            destination_airport_id: string | number;
            layover: string | number;
        }[];
        quoteVariants: {
            items: {
                label: string | number;
                isPerUnit?: string | number | boolean | object;
                per_unit_count: string | number;
                value: string | number;
                cost: string | number;
            }[];
            totalCost: string | number;
        }[];
        contacts: {
            providers: {
                name: string | number;
            };
            name: string | number;
            email: string | number;
            phone_number: string | number;
        }[];
    }[];
    showPivotWeight?: string | number | boolean | object;
    pivotWeight: string | number;
    weightUnit: string | number;
    awbNum: string | number;
    airlineRef: string | number;
    flightType: string | number;
    totalActualWeight: string | number;
    totalVolumeWeight: string | number;
    totalPieceCount: string | number;
    totalVolume: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    isKnownShipper: string | number;
    isPrescreened: string | number;
    cargoType: string | number;
    commodityType: string | number;
    showPerishable?: string | number | boolean | object;
    cargoTemperatureRange: string | number;
    cargoCooling: string | number;
    showDangerousGoods?: string | number | boolean | object;
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    showBatteries?: string | number | boolean | object;
    packing_instruction: string | number;
    section: string | number;
    tenantName?: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
    showTerms?: string | number | boolean | object;
    terms?: (string | number)[];
};
export type DOCUMENT_NOTIFICATION = {
    toContact: {
        preferred_name: string | number;
    };
    messageLines?: (string | number)[];
    url: string | number;
    tenantName?: string | number;
    confirmationNum: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type DUPLICATE_REQUEST = {
    authorName: string | number;
    oldRequestId: string | number;
    originIds: string | number;
    destinationIds: string | number;
    newRequestId: string | number;
    requestUrl: string | number;
    tenantName?: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type GENERIC_EMAIL_TO_AIRLINE = {
    toContact: {
        preferred_name: string | number;
    };
    messageLines?: (string | number)[];
    cancelReason?: string | number | boolean | object;
    tenantName?: string | number;
    confirmationNum: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type GENERIC_EMAIL_TO_FF = {
    toContact: {
        preferred_name: string | number;
    };
    messageLines?: (string | number)[];
    showBookingButton?: string | number | boolean | object;
    requestUrl: string | number;
    tenantName?: string | number;
    confirmationNum: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type INVITE_USER = {
    accountName: string | number;
    siteURL: string | number;
    tenantName?: string | number;
    redirectTo: string | number;
};
export type MAGIC_LINK = {
    tenantName?: string | number;
    confirmationUrl: string | number;
};
export type QUOTE_REQUEST_CLARIFICATION_TO_FF = {
    ffName: string | number;
    clarificationReasons?: (string | number)[];
    messageLines?: (string | number)[];
    weightUnit: string | number;
    totalActualWeight: string | number;
    totalVolumeWeight: string | number;
    totalPieceCount: string | number;
    totalVolume: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    isKnownShipper: string | number;
    isPrescreened: string | number;
    cargoType: string | number;
    commodityType: string | number;
    showPerishable?: string | number | boolean | object;
    cargoTemperatureRange: string | number;
    cargoCooling: string | number;
    showDangerousGoods?: string | number | boolean | object;
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    showBatteries?: string | number | boolean | object;
    packing_instruction: string | number;
    section: string | number;
    tenantName?: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type QUOTE_REQUEST_NOTIFICATION_EMAIL = {
    contentLine: string | number;
    ffCompany: string | number;
    origin: string | number;
    destination: string | number;
    airlineName: string | number;
    awbNum: string | number;
    tenantName?: string | number;
    confirmationNum: string | number;
};
export type QUOTE_REQUEST_TO_FF_MISSING_INFORMATION = {
    ffName: string | number;
    messages?: (string | number)[];
    from: string | number;
    subject: string | number;
    plainText: string | number;
    requestUrl: string | number;
};
export type QUOTE_REQUEST_TO_FF = {
    ffName: string | number;
    customMessage: string | number;
    origin: string | number;
    destination: string | number;
    isKnownShipper: string | number;
    productType: string | number;
    weightUnit: string | number;
    totalActualWeight: string | number;
    totalVolumeWeight: string | number;
    totalPieceCount: string | number;
    totalVolume: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    tentativeTender: string | number;
    isStackable: string | number;
    cargoType: string | number;
    commodityType: string | number;
    showPerishable?: string | number | boolean | object;
    cargoTemperatureRange: string | number;
    cargoCooling: string | number;
    showDangerousGoods?: string | number | boolean | object;
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    showBatteries?: string | number | boolean | object;
    packing_instruction: string | number;
    section: string | number;
    requestUrl: string | number;
    tenantName?: string | number;
    requestId: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type QUOTE_UPDATE_TO_FF = {
    ffName: string | number;
    messageLines?: (string | number)[];
    requestUrl: string | number;
    showQuotes?: string | number | boolean | object;
    quotesDetail: {
        providers: {
            name: string | number;
        };
        estimatedRouting: string | number;
        estimatedTotalTime: string | number;
        flightType: string | number;
        validUntil: string | number;
        quoteVariants: {
            name: string | number;
            items: {
                label: string | number;
                isPerUnit?: string | number | boolean | object;
                per_unit_count: string | number;
                value: string | number;
                cost: string | number;
            }[];
            kgCost: string | number;
            totalCost: string | number;
        }[];
    }[];
    weightUnit: string | number;
    tenantName?: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
    showTerms?: string | number | boolean | object;
    terms?: (string | number)[];
};
export type REQUEST_SCHEDULE = {
    toContact: {
        preferred_name: string | number;
    };
    messageLines?: (string | number)[];
    origin: string | number;
    destination: string | number;
    isKnownShipper: string | number;
    productType: string | number;
    targetRate: string | number;
    accountNumber: string | number;
    account: {
        name: string | number;
    };
    iataNumber: string | number;
    weightUnit: string | number;
    totalActualWeight: string | number;
    totalVolumeWeight: string | number;
    totalPieceCount: string | number;
    totalVolume: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    cancelReason?: string | number | boolean | object;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
    tenantName?: string | number;
};
export type TRACK_TRACE_DROPOFF = {
    request_id: string | number;
    customer_ref: string | number;
    from: string | number;
    to: string | number;
    request_piece_count: string | number;
    request_weight: string | number;
    bookingUrl: string | number;
    requestUrl: string | number;
    unsubscribeUrl: string | number;
    tenantName?: string | number;
    shipEmail: string | number;
};
export type TRACK_TRACE_UPDATE = {
    request_id: string | number;
    customer_ref: string | number;
    bookingUrl: string | number;
    requestUrl: string | number;
    from: string | number;
    to: string | number;
    request_piece_count: string | number;
    request_weight: string | number;
    supported?: string | number | boolean | object;
    events: {
        isNew?: string | number | boolean | object;
        raw_type: string | number;
        fetcher_id: string | number;
        flight_number: string | number | boolean | object;
        piece_count: string | number;
        weight: string | number;
        raw_airport_id: string | number;
        date: string | number;
    }[];
    fetchers: {
        id: string | number;
        trackingNumber: string | number;
        directLink: string | number;
    }[];
    unsubscribeUrl: string | number;
    tenantName?: string | number;
    shipEmail: string | number;
};
export type TRUCKING_QUOTING = {
    message?: (string | number)[];
    origin: string | number;
    destination: string | number;
    readyDate: string | number;
    weightUnit: string | number;
    totalActualWeight: string | number;
    totalPieceCount: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    isStackable: string | number;
    cargoType: string | number;
    commodityType: string | number;
    showPerishable?: string | number | boolean | object;
    cargoTemperatureRange: string | number;
    cargoCooling: string | number;
    showDangerousGoods?: string | number | boolean | object;
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    showBatteries?: string | number | boolean | object;
    packing_instruction: string | number;
    section: string | number;
    tenantName?: string | number;
    requestId: string | number;
    quoteId: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type VERIFY_EMAIL = {
    tenantName?: string | number;
    code: string | number;
    confirmationUrl: string | number;
};
export type WAREHOUSE_QUOTING = {
    message?: (string | number)[];
    destination: string | number;
    readyDate: string | number;
    weightUnit: string | number;
    totalActualWeight: string | number;
    totalPieceCount: string | number;
    dimensionUnit: string | number;
    cargos: {
        quantity: string | number;
        length: string | number;
        width: string | number;
        height: string | number;
        weight: string | number;
        isStackable: string | number;
    }[];
    isStackable: string | number;
    cargoType: string | number;
    commodityType: string | number;
    showPerishable?: string | number | boolean | object;
    cargoTemperatureRange: string | number;
    cargoCooling: string | number;
    showDangerousGoods?: string | number | boolean | object;
    un_number: string | number;
    class: string | number;
    packing_group: string | number;
    aircraft_restriction: string | number;
    showBatteries?: string | number | boolean | object;
    packing_instruction: string | number;
    section: string | number;
    tenantName?: string | number;
    requestId: string | number;
    quoteId: string | number;
    contentOnly?: string | number | boolean | object;
    fromContact: {
        name: string | number;
        title: string | number;
        phone_number?: string | number;
        email?: string | number;
    };
};
export type WELCOME_EMAIL = {
    tenantName?: string | number;
    ffName: string | number;
    homeUrl: string | number;
    requestQuoteUrl: string | number;
};
export enum EmailTemplateName {
    AIRLINE_BOOKING = "airline-booking.mjml",
    AIRLINE_QUOTING = "airline-quoting.mjml",
    BOOKING_CONFIRM_TO_FF = "booking-confirm-to-ff.mjml",
    DOCUMENT_NOTIFICATION = "document-notification.mjml",
    DUPLICATE_REQUEST = "duplicate-request.mjml",
    GENERIC_EMAIL_TO_AIRLINE = "generic-email-to-airline.mjml",
    GENERIC_EMAIL_TO_FF = "generic-email-to-ff.mjml",
    INVITE_USER = "invite-user.mjml",
    MAGIC_LINK = "magic-link.mjml",
    QUOTE_REQUEST_CLARIFICATION_TO_FF = "quote-request-clarification-to-ff.mjml",
    QUOTE_REQUEST_NOTIFICATION_EMAIL = "quote-request-notification-email.mjml",
    QUOTE_REQUEST_TO_FF_MISSING_INFORMATION = "quote-request-to-ff-missing-information.mjml",
    QUOTE_REQUEST_TO_FF = "quote-request-to-ff.mjml",
    QUOTE_UPDATE_TO_FF = "quote-update-to-ff.mjml",
    REQUEST_SCHEDULE = "request-schedule.mjml",
    TRACK_TRACE_DROPOFF = "track-trace-dropoff.mjml",
    TRACK_TRACE_UPDATE = "track-trace-update.mjml",
    TRUCKING_QUOTING = "trucking-quoting.mjml",
    VERIFY_EMAIL = "verify-email.mjml",
    WAREHOUSE_QUOTING = "warehouse-quoting.mjml",
    WELCOME_EMAIL = "welcome-email.mjml"
}
export type EmailParamMap = {
    [EmailTemplateName.AIRLINE_BOOKING]: AIRLINE_BOOKING;
    [EmailTemplateName.AIRLINE_QUOTING]: AIRLINE_QUOTING;
    [EmailTemplateName.BOOKING_CONFIRM_TO_FF]: BOOKING_CONFIRM_TO_FF;
    [EmailTemplateName.DOCUMENT_NOTIFICATION]: DOCUMENT_NOTIFICATION;
    [EmailTemplateName.DUPLICATE_REQUEST]: DUPLICATE_REQUEST;
    [EmailTemplateName.GENERIC_EMAIL_TO_AIRLINE]: GENERIC_EMAIL_TO_AIRLINE;
    [EmailTemplateName.GENERIC_EMAIL_TO_FF]: GENERIC_EMAIL_TO_FF;
    [EmailTemplateName.INVITE_USER]: INVITE_USER;
    [EmailTemplateName.MAGIC_LINK]: MAGIC_LINK;
    [EmailTemplateName.QUOTE_REQUEST_CLARIFICATION_TO_FF]: QUOTE_REQUEST_CLARIFICATION_TO_FF;
    [EmailTemplateName.QUOTE_REQUEST_NOTIFICATION_EMAIL]: QUOTE_REQUEST_NOTIFICATION_EMAIL;
    [EmailTemplateName.QUOTE_REQUEST_TO_FF_MISSING_INFORMATION]: QUOTE_REQUEST_TO_FF_MISSING_INFORMATION;
    [EmailTemplateName.QUOTE_REQUEST_TO_FF]: QUOTE_REQUEST_TO_FF;
    [EmailTemplateName.QUOTE_UPDATE_TO_FF]: QUOTE_UPDATE_TO_FF;
    [EmailTemplateName.REQUEST_SCHEDULE]: REQUEST_SCHEDULE;
    [EmailTemplateName.TRACK_TRACE_DROPOFF]: TRACK_TRACE_DROPOFF;
    [EmailTemplateName.TRACK_TRACE_UPDATE]: TRACK_TRACE_UPDATE;
    [EmailTemplateName.TRUCKING_QUOTING]: TRUCKING_QUOTING;
    [EmailTemplateName.VERIFY_EMAIL]: VERIFY_EMAIL;
    [EmailTemplateName.WAREHOUSE_QUOTING]: WAREHOUSE_QUOTING;
    [EmailTemplateName.WELCOME_EMAIL]: WELCOME_EMAIL;
};
